import { render, staticRenderFns } from "./C2bLogo.vue?vue&type=template&id=6aed1729"
import script from "./C2bLogo.vue?vue&type=script&lang=js"
export * from "./C2bLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports